import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography, Avatar, Button, Icon } from 'components'
import Popover from '@material-ui/core/Popover'
import { colors } from 'constants/index'
import { useDispatch, useSelector } from 'react-redux'
import { openSnackbar } from 'store/actions/common'
import { openChatModal } from 'store/actions/chat/chat'

const useStyles = makeStyles({
  popover: {
    padding: 16,
    minWidth: 300,
  },
  popoverContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  providerInfo: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  providerAvatarLarge: {
    width: 40,
    height: 40,
    fontSize: 16.25,
    fontWeight: 400,
  },
  providerDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  providerName: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '28px',
    color: '#011A33',
    marginBottom: 4,
  },
  emailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  providerEmail: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px',
    color: '#2B4157',
  },
  copyIcon: {
    width: 16,
    height: 16,
    cursor: 'pointer',
    color: '#2B4157',
  },
  writeMessageButton: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '12px',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
    width: '150px',
    height: '40px',
  },
})

const getInitials = (firstName, lastName) => {
  const first = firstName ? firstName.charAt(0).toUpperCase() : ''
  const last = lastName ? lastName.charAt(0).toUpperCase() : ''
  return first + last || '?'
}

const ProviderPopover = ({ provider, anchorEl, open, onClose }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.auth.currentUser)
  const isCurrentUser = provider?.username === currentUser?.username

  const handleCopyEmail = e => {
    e.stopPropagation()
    if (provider?.username) {
      navigator.clipboard.writeText(provider.username)
      dispatch(openSnackbar('success', 'Email copied to clipboard'))
    }
  }

  const handleWriteMessage = e => {
    e.stopPropagation()
    if (provider?.twilio_chat_sid) {
      dispatch(openChatModal(provider.twilio_chat_sid, 'cases'))
      onClose(e)
    }
  }

  if (!provider) return null

  const providerName = `${provider.first_name || ''} ${provider.last_name || ''}`.trim() || provider.username

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          border: '1px solid #DDE2EB',
          boxShadow: '2px 4px 24px 0px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <div className={classes.popover}>
        <div className={classes.popoverContent}>
          <div className={classes.providerInfo}>
            <Avatar className={classes.providerAvatarLarge} src={provider.photo_thumbnail || provider.photo || null}>
              {!provider.photo_thumbnail && !provider.photo && getInitials(provider.first_name, provider.last_name)}
            </Avatar>
            <div className={classes.providerDetails}>
              <Typography className={classes.providerName}>{providerName}</Typography>
              <div className={classes.emailRow}>
                <Typography className={classes.providerEmail}>{provider.username}</Typography>
                <Icon iconClass="las la-copy" className={classes.copyIcon} onClick={handleCopyEmail} />
              </div>
            </div>
          </div>
          {!isCurrentUser && (
            <Button
              color="secondary"
              variant="secondary"
              className={classes.writeMessageButton}
              onClick={handleWriteMessage}
              disabled={!provider?.twilio_chat_sid}
            >
              Write message
            </Button>
          )}
        </div>
      </div>
    </Popover>
  )
}

export default ProviderPopover
